<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-22 10:33:11
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-16 11:33:08
 * @FilePath: /chaoyongtuan/src/views/shopManage/orderDetails/list/components/tableCell/commandCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="command-cell">
		<div class="command-head flex flex-align-center">
			<div class="command-name font-h6-medium fz-12">{{ row.institution_name | formatEmpty | textFormat(4) }}</div>
			<div v-if="statusState" class="authority-status yx-color-text-regular">{{ row.authority_status || '已删除' }}</div>
		</div>
		<div class="command-bottom font-h6-medium fz-12">
			<el-tooltip placement="top" :open-delay="300">
				<div slot="content">
					<span>团长ID</span>
					<span class="ml-4">{{ row.authority_id || '-' }}</span>
					<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.authority_id)"></i>
				</div>
				<div class="font-h6-medium fz-12 pointer">团长ID：{{ row.authority_id | textFormat(10)}}</div>
			</el-tooltip>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { copy } from '@/utils/common';
export default {
	mixins: [mixin],
	components: {},
	computed: {
		statusState({ row }) {
			return row.authority_status && row.authority_status !== '已授权';
		},
	},
	data() {
		return {};
	},
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
};
</script>
<style lang="less" scoped>
.command-cell {
	.command-head {
		display: flex;
		align-items: center;
		.command-name {
			color: @color-text-primary;
		}
	}
	.command-bottom {
		color: @color-gy8;
	}
	.authority-status {
		margin-left: 4px;
		line-height: 20px;
		padding: 0 3px 0 3px;
		height: 20px;
		border-radius: 3px;
		border: 1px solid @color-gy4;
		font-size: 12px;
		font-family: PingFangSC-Regular;
	}
}
</style>
